import { defineMessages } from 'react-intl';

export const cartTotalItemsMessages = defineMessages({
    cartLabel: {
        id: 'orderSummary.cartLabel',
        description: 'Text for order summary label',
        defaultMessage: 'Cart - {cartCount} {cartCount, plural, one {item} other {items}}'
    },
    cartHeading: {
        id: 'orderSummary.cartHeading',
        description: 'Text for cart heading',
        defaultMessage: 'My Shopping Cart'
    }
});

export const emptyOrderSummaryMessages = defineMessages({
    emptyCartMessage: {
        id: 'orderSummary.emptyCartMessage',
        description: 'Message informing the user no items are present in the cart',
        defaultMessage: 'Your cart is empty.'
    },
    shopButtonText: {
        id: 'orderSummary.shopButtonText',
        description: 'Text for shop button',
        defaultMessage: 'Shop for Gift Cards'
    }
});

export const orderSummaryMessages = defineMessages({
    continueShoppingButtonText: {
        id: 'orderSummary.continueShoppingButtonText',
        description: 'Text for continue shopping button',
        defaultMessage: 'Continue Shopping'
    },
    backButtonText: {
        id: 'orderSummary.backButtonText',
        description: 'Text for back button',
        defaultMessage: 'Back'
    },
    checkOutButtonText: {
        id: 'orderSummary.checkOutButtonText',
        description: 'Text for check out button',
        defaultMessage: 'Check Out'
    },
    singlePaymentMethodError: {
        id: 'orderSummary.singlePaymentMethodError',
        description: 'Error alert when payment fails with single payment method.',
        defaultMessage: 'Oops! Something went wrong and your order could not be processed. Please try again. If you continue to see this error, please contact us.'
    },
    multiplePaymentMethodError: {
        id: 'orderSummary.multiplePaymentMethodError',
        description: 'Error alert when payment fails with multiple payment methods.',
        defaultMessage: 'There was a problem processing your payment. Please try another payment type.'
    },
    orderOverDailyLimit: {
        id: 'orderSummary.orderOverDailyLimit',
        description: 'Error message when the order placement fails with a 403 Error',
        defaultMessage:
            'Your order could not be processed because you have reached our daily gift card order limit of $10,000.'
    },
    orderPromosMayHaveChanged: {
        id: 'orderSummary.orderPromosMayHaveChanged',
        description: 'Error message when the order placement fails due to a promotion issue that might result in the promotions in the cart changing',
        defaultMessage:
            'The promotions in your shopping cart have changed. Please review your order and checkout again.'
    },
    orderOverPromoRedemptionLimit: {
        id: 'orderSummary.orderOverPromoRedemptionLimit',
        description: 'Error message when the order placement fails due to exceeding the promo redemption limit per purchaser.',
        defaultMessage:
            'Sorry, you\'ve reached the maximum purchase limit for this promotion. Please remove the promotional item from your cart and checkout again.'
    },
    orderMissingPaymentInfo: {
        id: 'orderSummary.orderMissingPaymentInfo',
        description: 'Error message when the payment data is missing crucial information',
        defaultMessage:
            'Please verify your billing information and try again, or use another payment method'
    },
});

export const orderSummaryDetailsMessages = defineMessages({
    egiftCardsLabel: {
        id: 'orderSummary.egiftCardsLabel',
        description: 'Text for egift cards label',
        defaultMessage: 'eGift {cartCount, plural, one {Card} other {Cards}}'
    },
    physicalGiftCardsLabel: {
        id: 'orderSummary.physicalGiftCardsLabel',
        description: 'Text for physical gift cards label',
        defaultMessage: 'Physical Gift {cartCount, plural, one {Card} other {Cards}}'
    }
});

export const orderSummaryTotalsMessages = defineMessages({
    orderSummaryLabel: {
        id: 'orderSummary.orderSummaryLabel',
        description: 'Text for order summary label',
        defaultMessage: 'Order Summary'
    },
    cardSubtotal: {
        id: 'orderSummary.cardSubtotal',
        description: 'Text for card subtotal label',
        defaultMessage: 'Card Subtotal ({quantity})'
    },
    shipping: {
        id: 'orderSummary.shipping',
        description: 'Text for shipping label',
        defaultMessage: 'Shipping'
    },
    discounts: {
        id: 'orderSummary.discounts',
        description: 'Text for discounts',
        defaultMessage: 'Discounts'
    },
    fees: {
        id: 'orderSummary.fees',
        description: 'Text for fees',
        defaultMessage: 'Card Fees ({feeQuantity})'
    },
    total: {
        id: 'orderSummary.total',
        description: 'Text for total label',
        defaultMessage: 'Total'
    }
});

export const orderSummaryTotalPointsMessages = defineMessages({
    orderSummaryLabel: {
        id: 'orderSummary.orderSummaryPointsLabel',
        description: 'Text for order summary for points label',
        defaultMessage: 'Review and Complete Order'
    },
    availableFlexDollars: {
        id: 'orderSummary.availableFlexDollars',
        description: 'Label for flex rewards dollars',
        defaultMessage: 'Available Flex Rewards Dollars'
    },
    cardValue: {
        id: 'orderSummary.cardValue',
        description: 'Text for card value label',
        defaultMessage: 'Card Value'
    },
    afterPurchaseBalance: {
        id: 'orderSummary.afterPurchaseBalance',
        description: 'Text for balance after purchase',
        defaultMessage: 'Flex Rewards Dollars After Purchase'
    },
    pointsTotalAmountDue: {
        id: 'orderSummary.pointsTotalAmountDue',
        description: 'Text for total label',
        defaultMessage: 'Amount Due'
    },
    shippingFeesDue: {
        id: 'orderSummary.shippingFeesDue',
        description: 'Text for shipping fees',
        defaultMessage: 'Shipping Fees'
    },
});

export const orderSummarySSOCheckout = defineMessages({
    checkoutPageHeader: {
        id: 'orderSummary.checkoutPageHeader',
        description: 'Text for order summary checkout page header',
        defaultMessage: 'Ready to check out?'
    },
    checkoutType: {
        id: 'orderSummary.accountCheckoutOptions',
        description: 'Text of a legend for tabbing between account checkout options',
        defaultMessage: 'Account Checkout options'
    },
    createAccountBtn: {
        id: 'orderSummary.createAccountBtn',
        description: 'Text for order summary create an account button',
        defaultMessage: 'Create an Account'
    },
    guestTabLabel: {
        id: 'orderSummary.guestTabLabel',
        description: 'Text for order summary guest checkout tab',
        defaultMessage: 'Checkout As Guest'
    },
    loginContainerText: {
        id: 'orderSummary.loginContainerText',
        description: 'Text for order summary login container text',
        defaultMessage: 'Use your Kroger account to earn fuel points, and have an easier checkout experience.'
    },
    loginTabLabel: {
        id: 'orderSummary.loginTabLabel',
        description: 'Text for order summary login checkout tab',
        defaultMessage: 'Log In/Sign Up'
    },
    signInBtn: {
        id: 'orderSummary.signInBtn',
        description: 'Text for order summary sign in button',
        defaultMessage: 'Sign In'
    },
    logInText: {
        id: 'orderSummary.logInText',
        description: 'Text for order summary log in link',
        defaultMessage: "Log in"
    },
    loggedInText: {
        id: 'orderSummary.loggedInText',
        description: 'Text for order summary logged in message',
        defaultMessage: "You're logged in as <b>{name}</b>. Not you?"
    },
});
